import { Button } from '@vapor/ui';
import { styled } from 'buttered';
import Link from 'next/link';
import { ArrowRight } from 'react-feather';

let Wrapper = styled('section')`
  background: var(--vapor-primary);
  color: var(--vapor-primary-text);
  padding: 100px 15px 0px 15px;
  width: 1600px;
  max-width: calc(100vw - 60px);
  margin: 0px auto 100px auto;
  border-radius: 70px;

  @media screen and (max-width: 800px) {
    padding: 60px 15px;
    border-radius: 30px;
    margin: 0px auto 50px auto;

    aside {
      display: none;
    }
  }
`;

let Content = styled('main')`
  max-width: 720px;
  margin: 0px auto;
  text-align: center;

  h1 {
    font-size: 60px;
    font-weight: 700;
    margin-bottom: 40px;

    @media screen and (max-width: 800px) {
      font-size: 30px;
    }
  }
`;

let Image = styled('figure')`
  padding: 0px;
  max-width: 1200px;
  margin: 80px auto 0px auto;
  display: flex;

  img {
    width: 100%;
    border-top-left-radius: var(--vapor-radius-big);
    border-top-right-radius: var(--vapor-radius-big);
    box-shadow: var(--vapor-shadow-medium);
    image-rendering: -webkit-optimize-contrast;
  }
`;

export let BottomCTA = ({
  title,
  action,
  actionLink,
  image
}: {
  title: React.ReactNode;
  action: string;
  actionLink: string;
  image: {
    src: string;
    label: string;
  };
}) => {
  return (
    <Wrapper>
      <Content>
        <h1>{title}</h1>

        <Link href={actionLink}>
          <a style={{ width: 'fit-content', margin: '0px auto' }}>
            <Button
              iconRight={<ArrowRight />}
              size="big"
              variant="secondary"
              style={{ margin: '0px auto' }}
            >
              {action}
            </Button>
          </a>
        </Link>
      </Content>

      <aside>
        <Image>
          <img src={image.src} alt={image.label} />
        </Image>
      </aside>
    </Wrapper>
  );
};
